export default __webpack_public_path__ + "static/media/boldog-csalad-az-uj-lakasban.2222528d.webp";